import clsx from 'clsx'
import type { ComponentProps } from 'react'

type Props = ComponentProps<'section'> & {
  isEditing: boolean
  isValid?: boolean
}

export const TLBookingSection = ({
  children,
  className,
  isEditing,
  isValid,
  ...props
}: Props) => (
  <section
    {...props}
    className={clsx('booking-step relative my-8 ', className, {
      '-mx-8 pt-16 px-8 pb-8 editing border-t border-b border-fv-orange-bright bg-fv-gray-100':
        isEditing,
      'valid border border-fv-gray rounded-sm bg-white pt-14 px-4 pb-4':
        isValid,
    })}
  >
    {children}
  </section>
)
